import Grid from '@components/Grid';

// styles
import s from './ViewerProfileFeedPreloader.sss';

export const ViewerProfileFeedPreloader: React.FC = () => {
  const placeholders = [];
  for (let i = 0; i < 4; i += 1) {
    placeholders.push(
      <Grid
        key={i}
        desktop={3}
        tablet={4}
        def={6}
      >
        <div className={s.imagePreloader} />
        <div className={s.actionButtonPreloader} />
      </Grid>,
    );
  }
  return (
    <Grid container={true} spacing={10}>
      {placeholders}
    </Grid>
  );
};

export default ViewerProfileFeedPreloader;
